import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'homey-h4',
  imports: [],
  templateUrl: './homey-h4.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeyH4Component {

}
